import axios from "axios";
import { Endpoints } from "config/endpoints";
import { IUserConfigurationParameters } from "models/UserConfigurationParameters";

interface IConfigurationParameterService {
  getServiceEndpoint(): string;
  fetchUserConfigurationParameters(paramList: string[]): Promise<IUserConfigurationParameters>;
}

export const ConfigurationParameterService: IConfigurationParameterService = {
  getServiceEndpoint: (): string => {
    return Endpoints.getEndpoint("REACT_APP_CONFIGURATION_PARAMETER_ENDPOINT");
  },

  fetchUserConfigurationParameters: async (parameters: string[]): Promise<IUserConfigurationParameters> => {
    const ConfigurationParameterServiceUrl = ConfigurationParameterService.getServiceEndpoint();
    const { data } = await axios.post(
      `${ConfigurationParameterServiceUrl}configurationParameters`,
      { parameters }
    );
    return data;
  },
};
